/**
 * AgriSolSec — mega-menu hover behavior.
 * On hover-capable devices, force <details> always-open (panel always rendered)
 * and toggle a `.is-active` class on the <details> to control visibility.
 * This decouples visibility from the <details> open/close mechanism, which
 * doesn't reliably trigger CSS transitions on every toggle.
 */
(function () {
  'use strict';

  var OPEN_DELAY = 40;

  function isHoverCapable() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function closeOthers(except) {
    document.querySelectorAll('header-menu details.mega-menu.is-active').forEach(function (d) {
      if (d !== except) d.classList.remove('is-active');
    });
  }

  function bind(menu) {
    if (menu.dataset.hoverBound === '1') return;
    menu.dataset.hoverBound = '1';

    var details = menu.querySelector('details.mega-menu');
    if (!details) return;
    var summary = details.querySelector('summary');

    // Force <details> always-open on hover-capable devices so the panel
    // stays in the render tree. Visibility is controlled via .is-active.
    if (isHoverCapable()) {
      details.setAttribute('open', '');
    }

    var openTimer = null;

    function clearTimers() {
      if (openTimer) { clearTimeout(openTimer); openTimer = null; }
    }

    function open(delay) {
      clearTimers();
      openTimer = setTimeout(function () {
        // Cursor may have already left the menu (and the entire header) before
        // this delayed open fires. If so, mouseleave on .header-wrapper will
        // have already run and found nothing to close — activating now would
        // strand the panel open with no way to dismiss it.
        if (!menu.matches(':hover')) return;
        closeOthers(details);
        details.classList.add('is-active');
      }, delay);
    }

    // Only mouseenter on a mega menu triggers anything. We deliberately do
    // NOT close on mouseleave — moving from a mega menu to a non-mega item
    // (Shop All, WhatsApp) should keep the previously-open panel showing.
    // Closing happens via (1) entering a different mega menu, which calls
    // closeOthers, or (2) leaving the entire header wrapper (bindHeaderLeave).
    menu.addEventListener('mouseenter', function () {
      if (!isHoverCapable()) return;
      open(OPEN_DELAY);
    });

    if (summary) {
      summary.addEventListener('click', function (e) {
        if (!isHoverCapable()) return;
        e.preventDefault();
        var link = summary.querySelector('a[href]');
        if (link && link.href) {
          window.location.href = link.href;
          return;
        }
        var dataUrl = summary.dataset.linkUrl;
        if (dataUrl && dataUrl !== '' && dataUrl !== '#') {
          window.location.href = dataUrl;
        }
      });
    }
  }

  function bindAll() {
    document.querySelectorAll('header-menu').forEach(bind);
  }

  function bindHeaderLeave() {
    var header = document.querySelector('.header-wrapper');
    if (!header) return;
    header.addEventListener('mouseleave', function () {
      if (!isHoverCapable()) return;
      closeOthers(null);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindAll();
      bindHeaderLeave();
    });
  } else {
    bindAll();
    bindHeaderLeave();
  }

  document.addEventListener('shopify:section:load', function () {
    bindAll();
    bindHeaderLeave();
  });
})();
